import React, { useEffect, useRef } from 'react';
import { WizeCareLogoOtp } from '../assets/svg/login-icons';
import { translate } from '../vendors/react-translate/ReactTranslate';
import { supportedLanguages } from '../assets/i18h/appTranslation';
import { RESPONDIO_CHANNEL_ID } from '../assets/appConstants';
import '../assets/stylesheets/respondio-chat.css';

const RespondioChat = ({language, t, onClose}) => {
  const loadingScreenRef = useRef(null);
  const isHebrew = language === supportedLanguages.he;

  const openChatWidget = () => {
    if (window.$respond && typeof window.$respond.do === 'function') {
      window.$respond.do("chat:open");
    }
  };

  const setupChatWidget = () => {
    if (window.$respond && typeof window.$respond.on === 'function') {
      window.$respond.on("chat:closed", function() {
        cleanupWidget();
        if (onClose) {
          onClose();
        }
      });
      
      window.$respond.on("chat:opened", function() {
        if (loadingScreenRef.current) {
          loadingScreenRef.current.style.display = 'none';
        }
      });
    } else {
      setTimeout(setupChatWidget, 100);
    }
  };

  const cleanupWidget = () => {
    // Remove the widget script
    const existingScript = document.getElementById('respondio__widget');
    if (existingScript) {
      existingScript.remove();
    }
    
    // Clean up global $respond object if it exists
    if (window.$respond && typeof window.$respond.destroy === 'function') {
      window.$respond.destroy();
    }
    
    // Remove the global $respond object
    if (window.$respond) {
      delete window.$respond;
    }
  };

  useEffect(() => {
    // Ensure loading screen is visible when component mounts
    if (loadingScreenRef.current) {
      loadingScreenRef.current.style.display = 'flex';
    }

    const WIDGET_URL = `https://cdn.respond.io/webchat/widget/widget.js?cId=${RESPONDIO_CHANNEL_ID}`;
    
    const script = document.createElement('script');
    script.id = 'respondio__widget';
    script.src = WIDGET_URL;
    script.async = true;
    document.head.appendChild(script);

    const timer = setTimeout(() => {
      openChatWidget();
      setupChatWidget();
    }, 2000);

    return () => {
      clearTimeout(timer);
      cleanupWidget();
    };
  }, [language, onClose]);

  return (
    <div className="respondio-chat-container">
      <div className="respondio-main-logo">
        <WizeCareLogoOtp />
      </div>

      <div
        ref={loadingScreenRef}
        className="respondio-loading-screen"
        data-direction={isHebrew ? 'rtl' : 'ltr'}
      >
        <div className="respondio-loading-spinner"></div>
        <div className="respondio-loading-title">
          {t('chat.loading.title')}
        </div>
        <div className="respondio-loading-subtitle">
          {t('chat.loading.subtitle')}
        </div>
      </div>
    </div>
  );
};

export default translate("chat")(RespondioChat); 